module.exports = __webpack_public_path__ + "media/images/icons/country_flags/la-67f27403e34d3229fa88b65526b58287.svg";